import postApi from '../api/postApi'
import * as url from '../api/url'

// Post Send Email API
export const postSendEmailAPI = (payload) => {
    return new Promise(async (resolve, reject) => {
      return postApi
        .post(url.POST_SEND_EMAIL , payload)
        .then(response => {
          if (response) {
            resolve(response)
          }
        })
        .catch(err => {
          reject(err.response)
        })
    })
  }